import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Target, CheckCircle2, TrendingUp } from 'lucide-react';

interface BoardReadySummaryCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function BoardReadySummaryCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: BoardReadySummaryCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium">Board-Ready Summary</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1 p-3 rounded-lg bg-muted/50">
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <Target className="h-3 w-3" />
                <span>Group Cash Position</span>
              </div>
              <div className="text-lg font-bold">£2.4M</div>
              <Badge className="bg-green-100 text-green-800 text-[10px]">🟢 Strong</Badge>
            </div>
            <div className="space-y-1 p-3 rounded-lg bg-muted/50">
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <CheckCircle2 className="h-3 w-3" />
                <span>Liquidity Ratio</span>
              </div>
              <div className="text-lg font-bold">2.8x</div>
              <div className="flex items-center gap-1">
                <CheckCircle2 className="h-3 w-3 text-green-600" />
                <TrendingUp className="h-3 w-3 text-green-600" />
              </div>
            </div>
            <div className="space-y-1 p-3 rounded-lg bg-muted/50">
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <Target className="h-3 w-3" />
                <span>Days Cash on Hand</span>
              </div>
              <div className="text-lg font-bold">87 days</div>
              <Badge className="bg-green-100 text-green-800 text-[10px]">+15% above avg</Badge>
            </div>
            <div className="space-y-1 p-3 rounded-lg bg-muted/50">
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <TrendingUp className="h-3 w-3" />
                <span>Cash Conversion</span>
              </div>
              <div className="text-lg font-bold">42 days</div>
              <Badge className="bg-green-100 text-green-800 text-[10px]">-5 days ✅</Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
